<template>
  <div class="forgetPasswordBody" :style=backgroundImg>
    <div class="logoBody">
      <el-image :src="imageLogo"/>
    </div>
    <el-row type="flex" justify="center" align="middle">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
         <el-col :xs="12" :sm="10" :md="10" :lg="10" :xl="12">
        <div class="dfvb">
          <img src="../../assets/images/back.png" alt="" style="width:100%;height:100%" srcset="">
        </div>
      </el-col>
        <retrieve-password @resetShow="setReset" v-if="resetShow === '1'"/>
        <transition name="el-zoom-in-top">
          <reset-password v-if="resetShow === '2'"/>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RetrievePassword from "./RetrievePassword";
import ResetPassword from "./ResetPassword";
import {mapState} from "vuex";

export default {
  name: "ForgetPassword",
  components: {
    RetrievePassword,
    ResetPassword
  },
  data() {
    return {
      backgroundImg: {
        backgroundImage: 'url(' + require('/src/assets/images/background/background-1.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      },
      resetShow: '1',
      imageLogo: require('/src/assets/images/logo/logo-1.png'),
    }
  },
  methods: {
    setReset() {
      this.resetShow = '2'
    }
  },
  computed: {
    ...mapState({})
  },
  watch: {}
}
</script>

<style scoped lang="scss">
.forgetPasswordBody {
  height: 100%;

  .logoBody {
    position: absolute;
    left: 30px;
    top: 20px;
  }

  .el-row {
    height: 100%;

    // .el-col {

    // }
  }
}
</style>